import { InPersonMeetingIcon } from "./InPersonMeetingIcon";

export default InPersonMeetingIcon;
